import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { BOOKING_URL } from "config/site";
import "./booking.css";

// Opens the Cal.com discovery-call scheduler in a modal. It renders as a real link,
// so ctrl/cmd-click, middle-click and no-JS all fall back to opening the page directly.
function BookCallButton({ className = "btn btn-primary rounded", children = "Book a discovery call", icon = true }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => e.key === "Escape" && setOpen(false);
    const overflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    window.addEventListener("keydown", onKey);
    return () => {
      document.body.style.overflow = overflow;
      window.removeEventListener("keydown", onKey);
    };
  }, [open]);

  const onClick = (e) => {
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
    e.preventDefault();
    setOpen(true);
  };

  return (
    <>
      <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className={className} onClick={onClick}>
        {icon && <i className="fa-regular fa-calendar-check me-2" />}
        {children}
      </a>
      {open &&
        createPortal(
          <div className="booking-overlay" onClick={() => setOpen(false)} role="presentation">
            <div
              className="booking-dialog"
              role="dialog"
              aria-modal="true"
              aria-label="Book a discovery call"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="booking-dialog-header">
                <div>
                  <strong>Book a discovery call</strong>
                  <span>Pick a time that works for you — 100% free, no obligation.</span>
                </div>
                <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className="booking-newtab">
                  Open in new tab <i className="fa-solid fa-arrow-up-right-from-square ms-1" />
                </a>
                <button type="button" className="booking-close" onClick={() => setOpen(false)} aria-label="Close">
                  <i className="fa-solid fa-xmark" />
                </button>
              </div>
              <iframe
                title="Schedule a discovery call with Dobedo Soft"
                src={`${BOOKING_URL}?embed=true&layout=month_view`}
                className="booking-frame"
              />
            </div>
          </div>,
          document.body
        )}
    </>
  );
}

export default BookCallButton;
